import { componentDimensions } from './dimensions';

export const commonStyles = {
  drawerFooter: {
    boxShadow: '0px -3px 7px 0px #0000000a'
  }
};

export const GRADIENT = `linear-gradient(150deg, rgb(64, 86, 244) 0%, rgb(136, 114, 240) 50%, rgb(229, 72, 383) 100%)`;

export const getLargeDrawerPaperStyles = theme => ({
  width: componentDimensions.drawer.large.width,
  [theme.breakpoints.down(componentDimensions.drawer.large.breakpoint)]: {
    width: componentDimensions.drawer.large.responsiveWidth
  }
});
